import React from 'react';
import { Box } from '@mui/material';

interface LightMarketingPageContainerProps {
  children: React.ReactNode;
}

const LightMarketingPageContainer: React.FC<LightMarketingPageContainerProps> = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#FFFFFF',
        position: 'relative',
      }}
    >
      {children}
    </Box>
  );
};

export default LightMarketingPageContainer;
